module.exports = {
    settings: {
        switchPicture: 'クリックして画像を変更',
        closeStore: '店を閉める',
        openStore: 'ストアを開く',
        edit: 'ストアを変更',
        administrator: '管理者',
        generalMember: '正会員',
        admin: '管理者',
        general: '正会員',
        cancel: 'キャンセル',
        sure: '確定',
        queryText: 'ユーザーグループを選択してください',
        store: {
            dialogMsg1: '現在のストアを開いてもよろしいですか?',
            dialogMsg2: '現在のストアを閉じてもよろしいですか?'
        },
        storeInfo: {
            dialogTitle: 'ストアを変更',
            storeName: '店舗名',
            storeId: '店舗番号',
            storeAddress: '店舗住所',
            cancel: 'キャンセル',
            save: '保 存',
            storeIdMsg: '店舗番号を入力してください',
            storeIdMsg1: '数字または文字を入力してください',
            storeNameMsg: '店舗名を入力してください',
            storeAddressMsg: '店舗の住所を入力してください',
            success: '店舗情報が正常に変更されました！',
            fail: '店舗情報の変更に失敗しました！'
        },
        label: { //标签页选项 タブオプション
            memAndAuth: 'メンバーと権限',
            memberManagement: '会員管理',
            userGroupPermissions: 'ユーザーグループ権限',
        },
        optionPage1: { //成员管理  会員管理
            addMember: 'メンバーを追加',
            allMember: '全部',
            generalMember: '正会員',
            administrator: '管理者',
            table: {
                nickName: '会員名',
                name: 'ユーザー名',
                group: 'ユーザーグループ',
                state: '状態',
                operation: '運営',
                updatde: '修正',
                delete: '取り除く',

                generalMember: '正会員',
                administrator: '管理者',
                valid: '有効',
                invalid: '無効です'
            }
        },
        optionPage2: { //用户组权限 ユーザーグループ権限
            addGroup: 'ユーザーグループを追加',
            sure: '確定',
            cancel: 'キャンセル',
            table: {
                operands: '操作対象',
                power: '権威',
                save: '保存'
            },
            permissions: {
                permissionType: [{
                    type: 'グッズ'
                }, {
                    type: 'ラベル'
                }, {
                    type: 'ゲートウェイ'
                }, {
                    type: 'テンプレート'
                }, {
                    type: 'インターフェース'
                }, ],
                permissionIndex: ['product', 'label', 'gateway', 'template', 'interface'],
                permission: {
                    product: [{
                        name: '新增商品',
                        whether: false,
                        permissionName: '新製品'
                    }, {
                        name: '修改商品',
                        whether: false,
                        permissionName: '製品を編集する'
                    }, {
                        name: '删除商品',
                        whether: false,
                        permissionName: '製品を削除'
                    }],
                    label: [{
                        name: '新增标签',
                        whether: false,
                        permissionName: 'タグを追加'
                    }, {
                        name: '删除标签',
                        whether: false,
                        permissionName: 'ラベルを削除'
                    }, {
                        name: '标签固件升级',
                        whether: false,
                        permissionName: 'ファームウェアのアップグレード'
                    }, ],
                    gateway: [{
                        name: '新增网关',
                        whether: false,
                        permissionName: '新しいゲートウェイ'
                    }, {
                        name: '修改网关',
                        whether: false,
                        permissionName: 'ゲートウェイを変更'
                    }, {
                        name: '删除网关',
                        whether: false,
                        permissionName: 'ゲートウェイを削除'
                    }, {
                        name: '网关固件升级',
                        whether: false,
                        permissionName: 'ファームウェアのアップグレード'
                    }],
                    template: [{
                        name: '查看模板',
                        whether: false,
                        permissionName: 'テンプレートを表示'
                    }, {
                        name: '新增模板',
                        whether: false,
                        permissionName: '新しいテンプレート'
                    }, {
                        name: '修改模板',
                        whether: false,
                        permissionName: 'テンプレートを変更'
                    }, {
                        name: '删除模板',
                        whether: false,
                        permissionName: 'テンプレートを削除'
                    }],
                    interface: [{
                        name: '思迅接口',
                        whether: false,
                        permissionName: 'Si Xun interface'
                    }, {
                        name: '银豹接口',
                        whether: false,
                        permissionName: 'Yin Bao Interface'
                    }, {
                        name: '云平台',
                        whether: false,
                        permissionName: 'Cloud platform interface'
                    }]
                }
            }
        },
        dialogMsgSetting: {
            cancel: 'キャンセル',
            sure: '確定',
            open: 'オープン',
            close: '閉じる'
        },
        dialogMsg: {
            cancel: 'キャンセル',
            sure: '確定'
        },
        dialogMsg2: {
            cancel: 'キャンセル',
            sure: '確定'
        },
        validMsg: { //校验提示信息   確認プロンプト情報
            memberName: '会員名を入力してください',
            name: 'ユーザー名を入力してください',
            nameValid: '文字または数字を入力してください',
            nameExist: 'ユーザーはすでに存在します',
            nameFail: '失敗しました。再入力してください',
            group: 'ユーザーグループを選択してください',
            status: 'ステータスを選択してください',
            password: 'パスワードを入力してください',
            password2: 'もう一度パスワードを入力してください',
            length1: '6-20桁のパスワードを入力してください',
            length2: '6〜20個のパスワードを繰り返し入力してください',
            passRule: 'ユーザーパスワードにスペースを含めることはできません',
            passRule2: 'ユーザーパスワードに中国語を含めることはできません',
            disPw: '2つのパスワードに矛盾があります'
        },
        dialogUpdate: { //修改成员  メンバーを変更する
            dialogTitle: '修正',
            nickName: '会員名',
            name: 'ユーザー名',
            group: 'ユーザーグループ',
            state: '状態',
            cancel: 'キャンセル',
            sure: '確定',
            generalMember: '正会員',
            administrator: '管理者',
            valid: '有効',
            invalid: '無効です',

            nameTip: '会員名を入力してください',
            success: 'ユーザーの変更に成功しました！',
            noGroup: 'ユーザーの変更に失敗しました。そのようなユーザーグループはありません！',
            fail: 'ユーザーの変更に失敗しました！',
            unUpdate: '編集管理者権限なし！'
        },
        dialogAdd: { //添加成员  メンバーを追加
            dialogTitle: '新しい増加',
            nickName: '会員名',
            name: 'ユーザー名',
            group: 'ユーザーグループ',
            state: '状態',
            password: 'パスワード',
            password2: 'パスワードを再入力してください',
            generalMember: '正会員',
            administrator: '管理者',
            valid: '有効',
            invalid: '無効です',

            nickNameMsg: '会員名を入力してください',
            nameMsg: 'ユーザー名を入力してください',
            groupMsg: 'ユーザーグループを選択してください',
            stateMsg: 'ステータスを選択してください',
            passwordMsg: 'パスワードを入力してください',
            passwordMsg2: 'もう一度パスワードを入力してください',
            cancel: 'キャンセル',
            sure: '確定',

            success: 'ユーザーを追加しました！',
            exist: 'ユーザーはすでに存在します',
            noGroup: 'ユーザーの追加に失敗しました。そのようなユーザーグループはありません！',
            fail: 'ユーザーを追加できませんでした！'
        },
        queryUser: {
            fail: '現在のストアユーザーのクエリに失敗しました！'
        },
        queryUserToGroup: {
            fail: '現在のユーザーグループのユーザーのクエリに失敗しました！'
        },
        showRole: {
            admin: '管理者',
            general: '正会員'
        },
        dialogdelete: {
            dialogMsg: 'メンバー{name}を削除してもよろしいですか?',
            dialogTitle: '取り除く',
            success: 'ユーザーを削除しました！',
            noPermission: '削除する権限がありません！',
            fail: 'ユーザーを削除できませんでした！',
            unDelete: '管理者権限は削除されていません！'
        },
        addGroups: {
            superAdministrator: '超级管理员',
            administrator: '管理员',
            generalMember: '普通成员',
            administrator2: '管理者',
            generalMember2: '正会員',
            // admin:'管理员(admin)',
            // general:'普通成员(user)',
            // superAdministrator2:'Super administrator',
            // administrator2:'Administrator',
            // generalMember2:'Ordinary member',
            // admin2:'Administrator(admin)',
            // general2:'Ordinary member(user)',

            success: 'ユーザーグループを追加しました！',
            exist: 'このユーザーグループは既に存在します！',
            fail: 'ユーザーグループを追加できませんでした！',
            // maxLimitNum:"用户组数量已达到上限",
            inputText: 'ユーザーグループを入力してください',
            add: '新しい増加',
            dialogMsg: '新しいユーザーグループ{GroupVal}を追加してもよろしいですか?'
        },
        deleteGroup: {
            dialogMsg: 'ユーザーグループを削除してもよろしいですか？現在のユーザーグループを削除すると、グループのすべてのメンバーが通常のメンバーとして再割り当てされます',
            dialogTitle: '削除する',
            success: 'ユーザーグループが正常に削除されました！',
            fail: 'ユーザーグループの削除に失敗しました！'
        },
        getGroup: {
            fail: 'すべての文字を取得できませんでした！'
        },
        queryPermission: {
            fail: '許可を取得できませんでした！'
        },
        updatePermission: {
            update: '保存',
            dialogMsg: '現在のユーザーグループ権限を保存するかどうか！',
            success: '権限が正常に変更されました！',
            fail: '権限を変更できませんでした！'
        },
        hint: {
            // missingRequestParameters:"リクエストパラメータがありません",
            openStoreSuccess: "店舗がオープンしました",
            openStoreFail: "ストアを開けませんでした",
            closeStoreSuccess: "店舗は正常に閉鎖されました",
            closeStoreFail: "店舗の閉鎖に失敗しました",
            getStoreInfoFail: "店舗情報の取得に失敗しました",
            alreadyExistGroup: "ユーザーグループは既に存在します",
            changeFail: "交換できませんでした",
            internal: "既存の組み込みユーザーグループ"

            // isNumAndEn:'ユーザーグループは、純粋な中国語または純粋な英語です'

        },
        upload: {
            // missingRequestParameters:"リクエストパラメータがありません",
            replaceFailed: "画像の交換に失敗しました",
            format: 'アップロードしたアバター画像はJPGおよびPNG形式でなければなりません!',
            size: '画像サイズは370 * 370以内である必要があります!',
            success: '画像が正常に変更されました',
            failed: '画像のアップロードに失敗しました'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/settings.js